import {
  AddAccessTokenToIndexedDB,
  AddSelectedMerchantToIndexedDB,
  AddUserProfileToIndexedDB,
  ClearAccessTokenFromIndexedDB,
  ClearAllCacheFromIndexedDB,
  ClearSelectedMerchantFromIndexedDB,
  ClearUserProfileFromIndexedDB,
  DeleteSelectedMerchantFromIndexedDB,
  DeleteUserProfileFromIndexedDB,
  GetAccessTokenFromIndexedDB,
  GetSelectedMerchantFromIndexedDB,
  GetUserProfileFromIndexedDB,
} from "@/IndexedDB/cacheIndexedDB";
import { SelectedMerchantModel } from "@/model/merchant/selectedMerchantModel";
import { UserModel } from "@/model/user/userModel";
import { AccessToken } from "./userHelper";

// #region AccessToken
export function GetAccessTokenIndexedDBKey(): IDBValidKey {
  return 1;
}

export const GetAccessTokenFromCache = async (): Promise<string | null> => {
  const key: IDBValidKey = GetAccessTokenIndexedDBKey();
  return await GetAccessTokenFromIndexedDB(key);
};

export const AddAccessTokenCache = async (accessToken: string): Promise<void> => {
  const key: IDBValidKey = GetAccessTokenIndexedDBKey();
  await AddAccessTokenToIndexedDB(key, accessToken);
};

export const ClearAccessTokenCache = async () => {
  await ClearAccessTokenFromIndexedDB();
};

export const CheckAccessTokenCacheValid = async (): Promise<boolean> => {
  let accessTokenCacheValid = true;
  let accessTokenCache: string | null = await GetAccessTokenFromCache();

  const accessToken = AccessToken();

  if (!accessTokenCache) {
    await AddAccessTokenCache(accessToken);
    accessTokenCache = accessToken;
  }

  if (accessTokenCache !== accessToken) {
    accessTokenCacheValid = false;
  }

  if (!accessTokenCacheValid) {
    await ClearAllCacheFromIndexedDB();
  }

  return accessTokenCacheValid;
};
// #endregion

// #region UserProfile
function GetUserProfileIndexedDBKey(userId: number): IDBValidKey {
  return userId ? userId : 0;
}

export const GetUserProfileFromCache = async (userId: number): Promise<UserModel | null> => {
  const key: IDBValidKey = GetUserProfileIndexedDBKey(userId);

  if (await CheckAccessTokenCacheValid()) {
    return await GetUserProfileFromIndexedDB(key);
  }

  return null;
};

export const AddUserProfileCache = async (userId: number, userProfile: UserModel): Promise<void> => {
  const key: IDBValidKey = GetUserProfileIndexedDBKey(userId);
  await AddUserProfileToIndexedDB(key, userProfile);
};

export const DeleteUserProfileCache = async (userId: number): Promise<void> => {
  const key: IDBValidKey = GetUserProfileIndexedDBKey(userId);
  await DeleteUserProfileFromIndexedDB(key);
};

export const ClearUserProfileCache = async (): Promise<void> => {
  await ClearUserProfileFromIndexedDB();
};
// #endregion

// #region SelectedMerchant
function GetSelectedMerchantIndexedDBKey(merchantId: number): IDBValidKey {
  return merchantId ? merchantId : 0;
}

export const GetSelectedMerchantFromCache = async (merchantId: number): Promise<SelectedMerchantModel | null> => {
  const key: IDBValidKey = GetSelectedMerchantIndexedDBKey(merchantId);

  if (await CheckAccessTokenCacheValid()) {
    return await GetSelectedMerchantFromIndexedDB(key);
  }

  return null;
};

export const AddSelectedMerchantCache = async (
  merchantId: number,
  selectedMerchant: SelectedMerchantModel
): Promise<void> => {
  const key: IDBValidKey = GetSelectedMerchantIndexedDBKey(merchantId);
  await AddSelectedMerchantToIndexedDB(key, selectedMerchant);
};

export const DeleteSelectedMerchantCache = async (merchantId: number): Promise<void> => {
  const key: IDBValidKey = GetSelectedMerchantIndexedDBKey(merchantId);
  await DeleteSelectedMerchantFromIndexedDB(key);
};

export const ClearSelectedMerchantCache = async (): Promise<void> => {
  await ClearSelectedMerchantFromIndexedDB();
};
// #endregion
